export { AriaAttr, AutocompleteValue, BxfAccordionExpansionPanelTypeEnum, BxfBadgeSizeEnum, BxfBadgeStyleEnum, BxfBadgeTypeEnum, BxfBadgeWeightEnum, BxfButtonSizeEnum, BxfButtonTypeEnum, BxfCardBackgroundColor, BxfCardCollapseButtonType, BxfCardHeaderType, BxfCardStackedType, BxfCardType, BxfChatBubbleType, BxfChatBubbleUserFeedback, BxfChatCanvasActiveContentEnum, BxfChatCanvasModeEnum, BxfChatCanvasWidthEnum, BxfDatePickerDateFormatEnum, BxfDatePickerSeparatorsEnum, BxfDatePickerTypeEnum, BxfDynamicPositionEnum, BxfFormValidationType, BxfIconStateEnum, BxfIconTypeEnum, BxfInlineMenuTriggerEnum, BxfInputTypeEnum, BxfLinkSizeEnum, BxfLinkStyleEnum, BxfNotificationBadgeTypeEnum, BxfNotificationFooterTypeEnum, BxfNotificationGroupTypeEnum, BxfNotificationStyleEnum, BxfNotificationToastTypeEnum, BxfOverlayTriggerEnum, BxfPopoverBackgroundColor, BxfPopoverTriggerEnum, BxfProgressIndicatorSizeEnum, BxfProgressIndicatorTypeEnum, BxfSelectInitialOption, BxfTabBarDeletableTypeEnum, BxfTargetAtrEnum, BxfValidatorsNameEnum, FocusSource, HasPopupValue, Key, KeyboardEventKey, LiveRegionPoliteness, Role, WindowEventMap } from '@blk/bxf-web-components';
import { defineCustomElement as defineCustomElement$1, BxfAccordionExpansionPanel as BxfAccordionExpansionPanel$1 } from '@blk/bxf-web-components/dist/components/bxf-accordion-expansion-panel.js';
import { defineCustomElement, BxfAccordion as BxfAccordion$1 } from '@blk/bxf-web-components/dist/components/bxf-accordion.js';
import { defineCustomElement as defineCustomElement$2, BxfBadge as BxfBadge$1 } from '@blk/bxf-web-components/dist/components/bxf-badge.js';
import { defineCustomElement as defineCustomElement$3, BxfButton as BxfButton$1 } from '@blk/bxf-web-components/dist/components/bxf-button.js';
import { defineCustomElement as defineCustomElement$5, BxfCalendarGroup as BxfCalendarGroup$1 } from '@blk/bxf-web-components/dist/components/bxf-calendar-group.js';
import { defineCustomElement as defineCustomElement$6, BxfCalendarSettings as BxfCalendarSettings$1 } from '@blk/bxf-web-components/dist/components/bxf-calendar-settings.js';
import { defineCustomElement as defineCustomElement$4, BxfCalendar as BxfCalendar$1 } from '@blk/bxf-web-components/dist/components/bxf-calendar.js';
import { defineCustomElement as defineCustomElement$8, BxfCardGroup as BxfCardGroup$1 } from '@blk/bxf-web-components/dist/components/bxf-card-group.js';
import { defineCustomElement as defineCustomElement$7, BxfCard as BxfCard$1 } from '@blk/bxf-web-components/dist/components/bxf-card.js';
import { defineCustomElement as defineCustomElement$9, BxfChatBubble as BxfChatBubble$1 } from '@blk/bxf-web-components/dist/components/bxf-chat-bubble.js';
import { defineCustomElement as defineCustomElement$a, BxfChatCanvas as BxfChatCanvas$1 } from '@blk/bxf-web-components/dist/components/bxf-chat-canvas.js';
import { defineCustomElement as defineCustomElement$b, BxfChatPromptBox as BxfChatPromptBox$1 } from '@blk/bxf-web-components/dist/components/bxf-chat-prompt-box.js';
import { defineCustomElement as defineCustomElement$c, BxfChatPromptCarousel as BxfChatPromptCarousel$1 } from '@blk/bxf-web-components/dist/components/bxf-chat-prompt-carousel.js';
import { defineCustomElement as defineCustomElement$e, BxfCheckboxGroup as BxfCheckboxGroup$1 } from '@blk/bxf-web-components/dist/components/bxf-checkbox-group.js';
import { defineCustomElement as defineCustomElement$d, BxfCheckbox as BxfCheckbox$1 } from '@blk/bxf-web-components/dist/components/bxf-checkbox.js';
import { defineCustomElement as defineCustomElement$f, BxfContextMenu as BxfContextMenu$1 } from '@blk/bxf-web-components/dist/components/bxf-context-menu.js';
import { defineCustomElement as defineCustomElement$g, BxfDataViz as BxfDataViz$1 } from '@blk/bxf-web-components/dist/components/bxf-data-viz.js';
import { defineCustomElement as defineCustomElement$h, BxfDateInput as BxfDateInput$1 } from '@blk/bxf-web-components/dist/components/bxf-date-input.js';
import { defineCustomElement as defineCustomElement$i, BxfDatePicker as BxfDatePicker$1 } from '@blk/bxf-web-components/dist/components/bxf-date-picker.js';
import { defineCustomElement as defineCustomElement$j, BxfDateRangePicker as BxfDateRangePicker$1 } from '@blk/bxf-web-components/dist/components/bxf-date-range-picker.js';
import { defineCustomElement as defineCustomElement$k, BxfDialog as BxfDialog$1 } from '@blk/bxf-web-components/dist/components/bxf-dialog.js';
import { defineCustomElement as defineCustomElement$m, BxfFormGroup as BxfFormGroup$1 } from '@blk/bxf-web-components/dist/components/bxf-form-group.js';
import { defineCustomElement as defineCustomElement$n, BxfFormItem as BxfFormItem$1 } from '@blk/bxf-web-components/dist/components/bxf-form-item.js';
import { defineCustomElement as defineCustomElement$l, BxfForm as BxfForm$1 } from '@blk/bxf-web-components/dist/components/bxf-form.js';
import { defineCustomElement as defineCustomElement$o, BxfIcon as BxfIcon$1 } from '@blk/bxf-web-components/dist/components/bxf-icon.js';
import { defineCustomElement as defineCustomElement$p, BxfInlineMenu as BxfInlineMenu$1 } from '@blk/bxf-web-components/dist/components/bxf-inline-menu.js';
import { defineCustomElement as defineCustomElement$q, BxfInputMask as BxfInputMask$1 } from '@blk/bxf-web-components/dist/components/bxf-input-mask.js';
import { defineCustomElement as defineCustomElement$r, BxfLink as BxfLink$1 } from '@blk/bxf-web-components/dist/components/bxf-link.js';
import { defineCustomElement as defineCustomElement$s, BxfModal as BxfModal$1 } from '@blk/bxf-web-components/dist/components/bxf-modal.js';
import { defineCustomElement as defineCustomElement$u, BxfNotificationGroup as BxfNotificationGroup$1 } from '@blk/bxf-web-components/dist/components/bxf-notification-group.js';
import { defineCustomElement as defineCustomElement$t, BxfNotification as BxfNotification$1 } from '@blk/bxf-web-components/dist/components/bxf-notification.js';
import { defineCustomElement as defineCustomElement$v, BxfNumericStepper as BxfNumericStepper$1 } from '@blk/bxf-web-components/dist/components/bxf-numeric-stepper.js';
import { defineCustomElement as defineCustomElement$w, BxfPill as BxfPill$1 } from '@blk/bxf-web-components/dist/components/bxf-pill.js';
import { defineCustomElement as defineCustomElement$x, BxfPillbox as BxfPillbox$1 } from '@blk/bxf-web-components/dist/components/bxf-pillbox.js';
import { defineCustomElement as defineCustomElement$y, BxfPopover as BxfPopover$1 } from '@blk/bxf-web-components/dist/components/bxf-popover.js';
import { defineCustomElement as defineCustomElement$z, BxfProgressIndicator as BxfProgressIndicator$1 } from '@blk/bxf-web-components/dist/components/bxf-progress-indicator.js';
import { defineCustomElement as defineCustomElement$B, BxfRadioGroup as BxfRadioGroup$1 } from '@blk/bxf-web-components/dist/components/bxf-radio-group.js';
import { defineCustomElement as defineCustomElement$A, BxfRadio as BxfRadio$1 } from '@blk/bxf-web-components/dist/components/bxf-radio.js';
import { defineCustomElement as defineCustomElement$C, BxfSearchField as BxfSearchField$1 } from '@blk/bxf-web-components/dist/components/bxf-search-field.js';
import { defineCustomElement as defineCustomElement$D, BxfSegmentedControl as BxfSegmentedControl$1 } from '@blk/bxf-web-components/dist/components/bxf-segmented-control.js';
import { defineCustomElement as defineCustomElement$E, BxfSelect as BxfSelect$1 } from '@blk/bxf-web-components/dist/components/bxf-select.js';
import { defineCustomElement as defineCustomElement$G, BxfTabBarItem as BxfTabBarItem$1 } from '@blk/bxf-web-components/dist/components/bxf-tab-bar-item.js';
import { defineCustomElement as defineCustomElement$F, BxfTabBar as BxfTabBar$1 } from '@blk/bxf-web-components/dist/components/bxf-tab-bar.js';
import { defineCustomElement as defineCustomElement$H, BxfTextArea as BxfTextArea$1 } from '@blk/bxf-web-components/dist/components/bxf-text-area.js';
import { defineCustomElement as defineCustomElement$I, BxfTextInput as BxfTextInput$1 } from '@blk/bxf-web-components/dist/components/bxf-text-input.js';
import { defineCustomElement as defineCustomElement$J, BxfToggle as BxfToggle$1 } from '@blk/bxf-web-components/dist/components/bxf-toggle.js';
import { defineCustomElement as defineCustomElement$K, BxfTooltip as BxfTooltip$1 } from '@blk/bxf-web-components/dist/components/bxf-tooltip.js';
import { defineCustomElement as defineCustomElement$L, BxfTypeAhead as BxfTypeAhead$1 } from '@blk/bxf-web-components/dist/components/bxf-type-ahead.js';
import { createComponent } from '@stencil/react-output-target/runtime';
import React from 'react';

const BxfAccordion = /* @__PURE__ */ createComponent({
  tagName: "bxf-accordion",
  elementClass: BxfAccordion$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onTabChanged: "tabChanged" },
  defineCustomElement: defineCustomElement
});
const BxfAccordionExpansionPanel = /* @__PURE__ */ createComponent({
  tagName: "bxf-accordion-expansion-panel",
  elementClass: BxfAccordionExpansionPanel$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onPanelClicked: "panelClicked" },
  defineCustomElement: defineCustomElement$1
});
const BxfBadge = /* @__PURE__ */ createComponent({
  tagName: "bxf-badge",
  elementClass: BxfBadge$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$2
});
const BxfButton = /* @__PURE__ */ createComponent({
  tagName: "bxf-button",
  elementClass: BxfButton$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onSplitButtonClicked: "splitButtonClicked" },
  defineCustomElement: defineCustomElement$3
});
const BxfCalendar = /* @__PURE__ */ createComponent({
  tagName: "bxf-calendar",
  elementClass: BxfCalendar$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onFooterClicked: "footerClicked",
    onCalendarValueChanged: "calendarValueChanged",
    onDateChanged: "dateChanged",
    onMonthChanged: "monthChanged",
    onYearChanged: "yearChanged",
    onDateSelected: "dateSelected",
    onSeparatorSelected: "separatorSelected",
    onCalendarSelected: "calendarSelected",
    onRangeDateSelectionChanged: "rangeDateSelectionChanged",
    onDateFormatSelected: "dateFormatSelected",
    onShortcutClicked: "shortcutClicked",
    onTodayButtonMenuItemClicked: "todayButtonMenuItemClicked",
    onKeyDisplayChanged: "keyDisplayChanged"
  },
  defineCustomElement: defineCustomElement$4
});
const BxfCalendarGroup = /* @__PURE__ */ createComponent({
  tagName: "bxf-calendar-group",
  elementClass: BxfCalendarGroup$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onCalendarSelected: "calendarSelected",
    onSelectedDatesChanged: "selectedDatesChanged",
    onKeyDisplayChanged: "keyDisplayChanged"
  },
  defineCustomElement: defineCustomElement$5
});
const BxfCalendarSettings = /* @__PURE__ */ createComponent({
  tagName: "bxf-calendar-settings",
  elementClass: BxfCalendarSettings$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onCalendarSelected: "calendarSelected",
    onSeparatorSelected: "separatorSelected",
    onDateFormatSelected: "dateFormatSelected"
  },
  defineCustomElement: defineCustomElement$6
});
const BxfCard = /* @__PURE__ */ createComponent({
  tagName: "bxf-card",
  elementClass: BxfCard$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onExpandedVertically: "expandedVertically",
    onExpandedHorizontally: "expandedHorizontally",
    onCardClicked: "cardClicked",
    onCardSelected: "cardSelected",
    onCollapsedVertically: "collapsedVertically",
    onCollapsedHorizontally: "collapsedHorizontally"
  },
  defineCustomElement: defineCustomElement$7
});
const BxfCardGroup = /* @__PURE__ */ createComponent({
  tagName: "bxf-card-group",
  elementClass: BxfCardGroup$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$8
});
const BxfChatBubble = /* @__PURE__ */ createComponent({
  tagName: "bxf-chat-bubble",
  elementClass: BxfChatBubble$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onFeedbackSubmitted: "feedbackSubmitted",
    onAdditionalFeedbackSubmitted: "additionalFeedbackSubmitted",
    onSuggestionBubbleClicked: "suggestionBubbleClicked",
    onCopyButtonClicked: "copyButtonClicked",
    onFollowUpQuestionClicked: "followUpQuestionClicked",
    onSimilarQuestionClicked: "similarQuestionClicked",
    onFeedbackToggled: "feedbackToggled",
    onSourcesAccordionToggled: "sourcesAccordionToggled",
    onChatBubbleDidRender: "chatBubbleDidRender"
  },
  defineCustomElement: defineCustomElement$9
});
const BxfChatCanvas = /* @__PURE__ */ createComponent({
  tagName: "bxf-chat-canvas",
  elementClass: BxfChatCanvas$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onEmbeddedPanelOpened: "embeddedPanelOpened",
    onEmbeddedPanelClosed: "embeddedPanelClosed",
    onContactClicked: "contactClicked",
    onResetClicked: "resetClicked",
    onRecentClicked: "recentClicked",
    onLoginClicked: "loginClicked",
    onLogoClicked: "logoClicked",
    onContentClosed: "contentClosed",
    onDismissClicked: "dismissClicked",
    onUserErrorResponse: "userErrorResponse",
    onRecentPromptsClosed: "recentPromptsClosed",
    onRecentPromptClicked: "recentPromptClicked",
    onFullScreenButtonClicked: "fullScreenButtonClicked",
    onEmbeddedPanelResizeStart: "embeddedPanelResizeStart",
    onEmbeddedPanelResizeEnd: "embeddedPanelResizeEnd",
    onEmbeddedPanelResizing: "embeddedPanelResizing",
    onContentScrolled: "contentScrolled"
  },
  defineCustomElement: defineCustomElement$a
});
const BxfChatPromptBox = /* @__PURE__ */ createComponent({
  tagName: "bxf-chat-prompt-box",
  elementClass: BxfChatPromptBox$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onValueChanged: "valueChanged",
    onSubmitClicked: "submitClicked",
    onActiveResponseCancelled: "activeResponseCancelled"
  },
  defineCustomElement: defineCustomElement$b
});
const BxfChatPromptCarousel = /* @__PURE__ */ createComponent({
  tagName: "bxf-chat-prompt-carousel",
  elementClass: BxfChatPromptCarousel$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onPromptSelected: "promptSelected" },
  defineCustomElement: defineCustomElement$c
});
const BxfCheckbox = /* @__PURE__ */ createComponent({
  tagName: "bxf-checkbox",
  elementClass: BxfCheckbox$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onCheckboxChanged: "checkboxChanged" },
  defineCustomElement: defineCustomElement$d
});
const BxfCheckboxGroup = /* @__PURE__ */ createComponent({
  tagName: "bxf-checkbox-group",
  elementClass: BxfCheckboxGroup$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onCheckboxGroupChanged: "checkboxGroupChanged",
    onSelectAllChanged: "selectAllChanged",
    onFormValueChanged: "formValueChanged"
  },
  defineCustomElement: defineCustomElement$e
});
const BxfContextMenu = /* @__PURE__ */ createComponent({
  tagName: "bxf-context-menu",
  elementClass: BxfContextMenu$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onContextMenuRightClicked: "contextMenuRightClicked",
    onContextMenuItemClicked: "contextMenuItemClicked",
    onZoomIn: "zoomIn",
    onZoomOut: "zoomOut",
    onContextMenuOpened: "contextMenuOpened",
    onContextMenuClosed: "contextMenuClosed"
  },
  defineCustomElement: defineCustomElement$f
});
const BxfDataViz = /* @__PURE__ */ createComponent({
  tagName: "bxf-data-viz",
  elementClass: BxfDataViz$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onChartInstance: "chartInstance" },
  defineCustomElement: defineCustomElement$g
});
const BxfDateInput = /* @__PURE__ */ createComponent({
  tagName: "bxf-date-input",
  elementClass: BxfDateInput$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onFormValueChanged: "formValueChanged",
    onValueChanged: "valueChanged",
    onFocusChanged: "focusChanged",
    onBlurChanged: "blurChanged"
  },
  defineCustomElement: defineCustomElement$h
});
const BxfDatePicker = /* @__PURE__ */ createComponent({
  tagName: "bxf-date-picker",
  elementClass: BxfDatePicker$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onBlurChanged: "blurChanged",
    onCalendarClosed: "calendarClosed",
    onCalendarOpened: "calendarOpened",
    onCalendarSelected: "calendarSelected",
    onCalendarValueChanged: "calendarValueChanged",
    onDateChanged: "dateChanged",
    onDateFormatSelected: "dateFormatSelected",
    onDateSelected: "dateSelected",
    onFocusChanged: "focusChanged",
    onFooterClicked: "footerClicked",
    onFormValueChanged: "formValueChanged",
    onMonthChanged: "monthChanged",
    onSeparatorSelected: "separatorSelected",
    onShortcutClicked: "shortcutClicked",
    onSuffixChanged: "suffixChanged",
    onTodayButtonMenuItemClicked: "todayButtonMenuItemClicked",
    onValueChanged: "valueChanged",
    onYearChanged: "yearChanged"
  },
  defineCustomElement: defineCustomElement$i
});
const BxfDateRangePicker = /* @__PURE__ */ createComponent({
  tagName: "bxf-date-range-picker",
  elementClass: BxfDateRangePicker$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onCalendarValueChanged: "calendarValueChanged",
    onCalendarShortcutClicked: "calendarShortcutClicked",
    onCalendarButtonClicked: "calendarButtonClicked",
    onCalendarClosed: "calendarClosed",
    onCalendarFooterClicked: "calendarFooterClicked",
    onCalendarOpened: "calendarOpened",
    onCalendarResetButtonMenuItemClicked: "calendarResetButtonMenuItemClicked",
    onCalendarSelected: "calendarSelected",
    onDateChanged: "dateChanged",
    onDateSelected: "dateSelected",
    onEndValueChanged: "endValueChanged",
    onFocusChanged: "focusChanged",
    onFormValueChanged: "formValueChanged",
    onInvalidInputDate: "invalidInputDate",
    onMonthChanged: "monthChanged",
    onStartValueChanged: "startValueChanged",
    onValueChanged: "valueChanged",
    onYearChanged: "yearChanged"
  },
  defineCustomElement: defineCustomElement$j
});
const BxfDialog = /* @__PURE__ */ createComponent({
  tagName: "bxf-dialog",
  elementClass: BxfDialog$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onPrimaryButtonClicked: "primaryButtonClicked",
    onSecondaryButtonClicked: "secondaryButtonClicked",
    onDialogOpened: "dialogOpened",
    onDialogClosed: "dialogClosed"
  },
  defineCustomElement: defineCustomElement$k
});
const BxfForm = /* @__PURE__ */ createComponent({
  tagName: "bxf-form",
  elementClass: BxfForm$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$l
});
const BxfFormGroup = /* @__PURE__ */ createComponent({
  tagName: "bxf-form-group",
  elementClass: BxfFormGroup$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$m
});
const BxfFormItem = /* @__PURE__ */ createComponent({
  tagName: "bxf-form-item",
  elementClass: BxfFormItem$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$n
});
const BxfIcon = /* @__PURE__ */ createComponent({
  tagName: "bxf-icon",
  elementClass: BxfIcon$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$o
});
const BxfInlineMenu = /* @__PURE__ */ createComponent({
  tagName: "bxf-inline-menu",
  elementClass: BxfInlineMenu$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onInlineMenuItemClicked: "inlineMenuItemClicked",
    onMenuOpened: "menuOpened",
    onMenuClosed: "menuClosed"
  },
  defineCustomElement: defineCustomElement$p
});
const BxfInputMask = /* @__PURE__ */ createComponent({
  tagName: "bxf-input-mask",
  elementClass: BxfInputMask$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onFormValueChanged: "formValueChanged",
    onValueChanged: "valueChanged",
    onFocusChanged: "focusChanged",
    onBlurChanged: "blurChanged",
    onRawValueChanged: "rawValueChanged",
    onPrefixClicked: "prefixClicked",
    onSuffixClicked: "suffixClicked"
  },
  defineCustomElement: defineCustomElement$q
});
const BxfLink = /* @__PURE__ */ createComponent({
  tagName: "bxf-link",
  elementClass: BxfLink$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$r
});
const BxfModal = /* @__PURE__ */ createComponent({
  tagName: "bxf-modal",
  elementClass: BxfModal$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onModalOpened: "modalOpened",
    onModalClosed: "modalClosed",
    onPrimaryButtonClicked: "primaryButtonClicked",
    onSecondaryButtonClicked: "secondaryButtonClicked"
  },
  defineCustomElement: defineCustomElement$s
});
const BxfNotification = /* @__PURE__ */ createComponent({
  tagName: "bxf-notification",
  elementClass: BxfNotification$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onButtonClicked: "buttonClicked",
    onNotificationClosed: "notificationClosed",
    onNotificationIconClicked: "notificationIconClicked"
  },
  defineCustomElement: defineCustomElement$t
});
const BxfNotificationGroup = /* @__PURE__ */ createComponent({
  tagName: "bxf-notification-group",
  elementClass: BxfNotificationGroup$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onButtonClicked: "buttonClicked",
    onNotificationClosed: "notificationClosed"
  },
  defineCustomElement: defineCustomElement$u
});
const BxfNumericStepper = /* @__PURE__ */ createComponent({
  tagName: "bxf-numeric-stepper",
  elementClass: BxfNumericStepper$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onValueChanged: "valueChanged",
    onInputBlur: "inputBlur",
    onInputFocus: "inputFocus",
    onFormValueChanged: "formValueChanged"
  },
  defineCustomElement: defineCustomElement$v
});
const BxfPill = /* @__PURE__ */ createComponent({
  tagName: "bxf-pill",
  elementClass: BxfPill$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onClickClear: "clickClear",
    onChanged: "changed"
  },
  defineCustomElement: defineCustomElement$w
});
const BxfPillbox = /* @__PURE__ */ createComponent({
  tagName: "bxf-pillbox",
  elementClass: BxfPillbox$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onClearAllClicked: "clearAllClicked",
    onPillboxChanged: "pillboxChanged",
    onFormValueChanged: "formValueChanged"
  },
  defineCustomElement: defineCustomElement$x
});
const BxfPopover = /* @__PURE__ */ createComponent({
  tagName: "bxf-popover",
  elementClass: BxfPopover$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onPopoverOpened: "popoverOpened",
    onPopoverClosed: "popoverClosed",
    onIconClicked: "iconClicked"
  },
  defineCustomElement: defineCustomElement$y
});
const BxfProgressIndicator = /* @__PURE__ */ createComponent({
  tagName: "bxf-progress-indicator",
  elementClass: BxfProgressIndicator$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {},
  defineCustomElement: defineCustomElement$z
});
const BxfRadio = /* @__PURE__ */ createComponent({
  tagName: "bxf-radio",
  elementClass: BxfRadio$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: { onRadioChanged: "radioChanged" },
  defineCustomElement: defineCustomElement$A
});
const BxfRadioGroup = /* @__PURE__ */ createComponent({
  tagName: "bxf-radio-group",
  elementClass: BxfRadioGroup$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onRadioGroupChanged: "radioGroupChanged",
    onRadioChanged: "radioChanged",
    onFormValueChanged: "formValueChanged"
  },
  defineCustomElement: defineCustomElement$B
});
const BxfSearchField = /* @__PURE__ */ createComponent({
  tagName: "bxf-search-field",
  elementClass: BxfSearchField$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onSearchValueChanged: "searchValueChanged",
    onClickSearch: "clickSearch",
    onClickAdvancedSearch: "clickAdvancedSearch",
    onSearchSelectionChanged: "searchSelectionChanged",
    onFormValueChanged: "formValueChanged",
    onViewAllClicked: "viewAllClicked",
    onAddClicked: "addClicked",
    onPillboxChanged: "pillboxChanged",
    onInputValueChanged: "inputValueChanged"
  },
  defineCustomElement: defineCustomElement$C
});
const BxfSegmentedControl = /* @__PURE__ */ createComponent({
  tagName: "bxf-segmented-control",
  elementClass: BxfSegmentedControl$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onSegmentedControlClicked: "segmentedControlClicked",
    onControlSelectionChanged: "controlSelectionChanged",
    onPopoverClosed: "popoverClosed",
    onPopoverOpened: "popoverOpened"
  },
  defineCustomElement: defineCustomElement$D
});
const BxfSelect = /* @__PURE__ */ createComponent({
  tagName: "bxf-select",
  elementClass: BxfSelect$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onAdvancedSelectionChanged: "advancedSelectionChanged",
    onSelectionChanged: "selectionChanged",
    onTypeaheadValueChanged: "typeaheadValueChanged",
    onDropdownOpened: "dropdownOpened",
    onDropdownClosed: "dropdownClosed",
    onClearButtonClicked: "clearButtonClicked",
    onFormValueChanged: "formValueChanged",
    onApplyButtonClicked: "applyButtonClicked"
  },
  defineCustomElement: defineCustomElement$E
});
const BxfTabBar = /* @__PURE__ */ createComponent({
  tagName: "bxf-tab-bar",
  elementClass: BxfTabBar$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onTabBarItemAdded: "tabBarItemAdded",
    onTabBarItemDeleted: "tabBarItemDeleted",
    onTabBarItemRenamed: "tabBarItemRenamed",
    onTabBarItemSelected: "tabBarItemSelected",
    onTabBarItemPinned: "tabBarItemPinned",
    onTabBarItemDragged: "tabBarItemDragged",
    onTabBarAddIconClicked: "tabBarAddIconClicked",
    onTabBarItemIconClicked: "tabBarItemIconClicked"
  },
  defineCustomElement: defineCustomElement$F
});
const BxfTabBarItem = /* @__PURE__ */ createComponent({
  tagName: "bxf-tab-bar-item",
  elementClass: BxfTabBarItem$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onSelected: "selected",
    onEditing: "editing",
    onEdited: "edited",
    onDeleted: "deleted",
    onAdded: "added",
    onPinned: "pinned",
    onTabUidChanged: "tabUidChanged",
    onAction: "action",
    onFocused: "focused"
  },
  defineCustomElement: defineCustomElement$G
});
const BxfTextArea = /* @__PURE__ */ createComponent({
  tagName: "bxf-text-area",
  elementClass: BxfTextArea$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onValueChanged: "valueChanged",
    onInputBlur: "inputBlur",
    onInputFocus: "inputFocus",
    onFormValueChanged: "formValueChanged"
  },
  defineCustomElement: defineCustomElement$H
});
const BxfTextInput = /* @__PURE__ */ createComponent({
  tagName: "bxf-text-input",
  elementClass: BxfTextInput$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onValueChanged: "valueChanged",
    onInputFocus: "inputFocus",
    onInputBlur: "inputBlur",
    onInputChange: "inputChange",
    onPrefixClicked: "prefixClicked",
    onSuffixClicked: "suffixClicked",
    onInputEventChanged: "inputEventChanged",
    onFormValueChanged: "formValueChanged",
    onClearButtonClicked: "clearButtonClicked"
  },
  defineCustomElement: defineCustomElement$I
});
const BxfToggle = /* @__PURE__ */ createComponent({
  tagName: "bxf-toggle",
  elementClass: BxfToggle$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onFormValueChanged: "formValueChanged",
    onToggleChanged: "toggleChanged"
  },
  defineCustomElement: defineCustomElement$J
});
const BxfTooltip = /* @__PURE__ */ createComponent({
  tagName: "bxf-tooltip",
  elementClass: BxfTooltip$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onTooltipOpened: "tooltipOpened",
    onTooltipClosed: "tooltipClosed"
  },
  defineCustomElement: defineCustomElement$K
});
const BxfTypeAhead = /* @__PURE__ */ createComponent({
  tagName: "bxf-type-ahead",
  elementClass: BxfTypeAhead$1,
  // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
  react: React,
  events: {
    onDropdownOpened: "dropdownOpened",
    onDropdownClosed: "dropdownClosed",
    onTypeaheadValueChanged: "typeaheadValueChanged",
    onInputValueChanged: "inputValueChanged",
    onTypeaheadSelectionChanged: "typeaheadSelectionChanged",
    onViewAllClicked: "viewAllClicked",
    onAddClicked: "addClicked",
    onPillboxChanged: "pillboxChanged",
    onOptionDidRender: "optionDidRender",
    onPillDidRender: "pillDidRender",
    onFormValueChanged: "formValueChanged",
    onOverlayClickedOutside: "overlayClickedOutside"
  },
  defineCustomElement: defineCustomElement$L
});

export { BxfAccordion, BxfAccordionExpansionPanel, BxfBadge, BxfButton, BxfCalendar, BxfCalendarGroup, BxfCalendarSettings, BxfCard, BxfCardGroup, BxfChatBubble, BxfChatCanvas, BxfChatPromptBox, BxfChatPromptCarousel, BxfCheckbox, BxfCheckboxGroup, BxfContextMenu, BxfDataViz, BxfDateInput, BxfDatePicker, BxfDateRangePicker, BxfDialog, BxfForm, BxfFormGroup, BxfFormItem, BxfIcon, BxfInlineMenu, BxfInputMask, BxfLink, BxfModal, BxfNotification, BxfNotificationGroup, BxfNumericStepper, BxfPill, BxfPillbox, BxfPopover, BxfProgressIndicator, BxfRadio, BxfRadioGroup, BxfSearchField, BxfSegmentedControl, BxfSelect, BxfTabBar, BxfTabBarItem, BxfTextArea, BxfTextInput, BxfToggle, BxfTooltip, BxfTypeAhead };
//# sourceMappingURL=index.js.map
